import React, { useEffect, useState } from "react";
import Select, { StylesConfig } from "react-select";

interface SelectProps {
    options: { label: string; value: string }[];
    onChange?: (selectedOption: { label: string; value: string } | null) => void;
    value?: { label: string; value: string } | null;
    placeholder?: string
}

export const SelectCustom: React.FC<SelectProps> = ({ options, onChange, value, placeholder }) => {
    const handleChange = (option: { label: string; value: string } | null) => {
        if(onChange) {
            onChange(option);
        }
    };

    const colourStyles: StylesConfig<any> = {
        control: (provided) => ({
            ...provided,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            overflow: 'hidden',
            textAlign: 'left',
            width: '100%',
            padding: '5px',
            borderRadius: '10px',
            backgroundColor: '#F9F9F9',
            border: 'none',
            boxShadow: 'none',
        }),
        option: (provider, { isFocused }) => ({
            ...provider,
            padding: "12px",
            cursor: "pointer",
            color: "#000",
            backgroundColor: isFocused ? '#fffaea' : '#fff',
            ':active': {
                ...provider[':active'],
                backgroundColor: "#fffaea",
            },
        }),
        menu: (provided) => ({
            ...provided,
            justifyContent: 'center',
            alignContent: 'center',
            flexWrap: 'wrap',
            height: 'auto',
            flexShrink: 0,
            borderRadius: '10px',
            background: '#FFF',
            boxShadow: '0 4px 35px 0 rgba(122, 130, 146, 0.20)',
            cursor: 'pointer',
            padding: '12px 16px',
        }),
        menuList: (provided) => ({
            ...provided,
            transition: 'height 0.3s ease',
            'msOverflowStyle': 'none',
            'scrollbarWidth': 'none',
            '::-webkit-scrollbar': {
                display: 'none',
            },
        }),
    };

    const formatOptionLabel = ({ label }: any) => (
        <span dangerouslySetInnerHTML={{ __html: label }}></span>
    );

    return (
        <Select
            placeholder={ placeholder || 'Select...' }
            className="w-full outline-none border-none"
            value={ value }
            onChange={ handleChange }
            options={ options }
            styles={ colourStyles }
            formatOptionLabel={ formatOptionLabel }
        />
    );
};
